export default function Gallery() {
  const images = ["/cars/dzire.jpg", "/cars/ertiga.jpg", "/cars/innova.jpg"];

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold mb-6">Gallery</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {images.map((img, idx) => (
          <img key={idx} src={img} alt={`Gallery ${idx}`} className="rounded-md shadow-lg" />
        ))}
      </div>
    </div>
  );
}
